import soundEffects from '../../utils/soundEffects';

/**
 * Holes Selector Component
 * Toggle between 9 and 18 holes
 * Shows Front 9 / Back 9 selection when 9 holes is chosen
 */
const HolesSelector = ({ 
  numberOfHoles, 
  onHolesChange,
  startingNine = 'front',
  onStartingNineChange,
  disabled = false,
  className = ''
}) => {
  const handleHolesChange = (holes) => {
    soundEffects.playSwish();
    onHolesChange(holes);
  };

  const handleNineChange = (nine) => {
    soundEffects.playSwish();
    if (onStartingNineChange) {
      onStartingNineChange(nine);
    }
  };

  return (
    <div className={`space-y-4 ${className}`}>
      {/* 9 vs 18 Holes Selection */}
      <div className="flex items-center justify-center gap-8">
        <button
          type="button"
          onClick={() => handleHolesChange(9)}
          disabled={disabled}
          className={`text-xl font-bold transition-all ${
            numberOfHoles === 9
              ? 'text-[var(--ps-primary)] scale-110'
              : 'text-[var(--ps-text-muted)] hover:text-[var(--ps-text-secondary)]'
          }`}
          data-testid="9-holes-btn"
        >
          9 Holes
        </button>
        <span className="text-[var(--ps-text-muted)]">|</span>
        <button
          type="button"
          onClick={() => handleHolesChange(18)}
          disabled={disabled}
          className={`text-xl font-bold transition-all ${
            numberOfHoles === 18
              ? 'text-[var(--ps-primary)] scale-110'
              : 'text-[var(--ps-text-muted)] hover:text-[var(--ps-text-secondary)]'
          }`}
          data-testid="18-holes-btn"
        >
          18 Holes
        </button>
      </div>

      {/* Front 9 / Back 9 Selection - only shown when 9 holes is selected */}
      {numberOfHoles === 9 && onStartingNineChange && (
        <div className="pt-2">
          <p className="text-center text-sm text-[var(--ps-text-secondary)] mb-3">Which nine are you playing?</p>
          <div className="flex items-center justify-center gap-8">
            <button
              type="button"
              onClick={() => handleNineChange('front')}
              disabled={disabled}
              className={`text-lg font-bold transition-all ${
                startingNine === 'front'
                  ? 'text-[var(--ps-primary)] scale-105'
                  : 'text-[var(--ps-text-muted)] hover:text-[var(--ps-text-secondary)]'
              }`}
              data-testid="front-9-btn"
            >
              Front 9
              <span className="block text-xs font-normal text-[var(--ps-text-muted)]">(Holes 1-9)</span>
            </button>
            <span className="text-[var(--ps-text-muted)]">|</span>
            <button
              type="button"
              onClick={() => handleNineChange('back')}
              disabled={disabled}
              className={`text-lg font-bold transition-all ${
                startingNine === 'back'
                  ? 'text-[var(--ps-primary)] scale-105'
                  : 'text-[var(--ps-text-muted)] hover:text-[var(--ps-text-secondary)]'
              }`}
              data-testid="back-9-btn"
            >
              Back 9
              <span className="block text-xs font-normal text-[var(--ps-text-muted)]">(Holes 10-18)</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HolesSelector;
